import projection from '../generated/pwj503f1.json'; import { AcceptanceManifest } from '../types';
export const pwj503f1AcceptanceManifest = projection as AcceptanceManifest;
